import { getFromStorage } from "./localStorageUtils";

export default function extractFirebasePath(url?: string) {
    // The path typically starts after /o/
    const profile = getFromStorage("ally-user");

    const parts = url?.split("/o/");
    if (parts.length > 1) {
        let objectPath = parts[1];
        const queryIndex = objectPath.indexOf("?");
        if (queryIndex !== -1) {
            objectPath = objectPath.substring(0, queryIndex);
        }
        return objectPath;
    }
    const name = `${Date.now()}-purchase-order`;
    return `synthally/${process.env.REACT_APP_STAGE}/document/${profile?.user?.profile?.businessName}/${name}`;
}
